var body = $('body');

$(function () {
    'use strict';
    search();
    featured();
    video();
    gallery();
    table();
    mobileMenu();
    swiperConfig()    
    loopThroughTag()

});

function excludedLinks(){
    let postBodyLinks = document.getElementById('post-body')?.querySelectorAll('a')
    if(postBodyLinks){
        
        postBodyLinks.forEach(post=>{
            if(!(post.getAttribute('href')).startsWith('#')){
                console.log(post.getAttribute('href'))

                post.setAttribute("target","_blank")
                post.classList.add('excluded-link')
            }else{
                console.log(post.getAttribute('href'))
                post.dataset.newTab = 'no'
                post.setAttribute("target","_self")
            }
        
        })
    }
}

function swiperConfig(){
  const swiper = new Swiper('.swiper', {
    // Optional parameters
    direction: 'horizontal',
    slidesPerView: 2,
    loop: false,
  
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });
}

function loopThroughTag() {
    var exceptionLinks = [
        `${siteUrl}/articles`,
        `${siteUrl}/`,
        `${siteUrl}/announcements`,
        `${siteUrl}/blog`,
        `${siteUrl}/case-study`,
        `${siteUrl}/events`,
        `${siteUrl}/helium`,
        `${siteUrl}/product-reviews`,
        `${siteUrl}/thought-leadership`,
        `${siteUrl}/authors`,        
    ]

    excludedLinks()

    let aTags = document.querySelectorAll("a")
    aTags.forEach(tag=>{
        let tagClassList = tag.classList
        let isExcluded= false
        // if(!(tag.classList).includes("exluded-link")){
        //     tag.setAttribute("target","_self")
        // }
        if(tagClassList){
            Object.values(tagClassList).forEach(classList=>{
                // console.log("TAG: ", tag)
                if(classList === 'excluded-link'){
                    if(tag?.dataset?.newTab === 'no'){
                        isExcluded = false
                    }else{
                        isExcluded = true
                    }
                    return
                }
                
            })
            if(!isExcluded){
                tag.setAttribute("target","_self")
            }
            if(isExcluded){
                tag.setAttribute("target","_blank")
            }

        }

        
    })
    /**
    for (var i = 0; i < tag.length; i++) {
        var currentLink = tag[i].href;
        tag[i].setAttribute("target","_self")
         
        if(currentLink.includes(`https://${window.location.host}`)||exceptionLinks.includes(currentLink)){
            tag[i].setAttribute("target","_self")
        } else {
            tag[i].setAttribute("target","_blank")

        }
         
        if (exceptionLinks.includes(currentLink)) {
            console.table("Exception Links",currentLink)

            tag[i].setAttribute("target", "_self")
        }
        else if(currentLink.includes("page/")){
            console.table("/page",currentLink)

            tag[i].setAttribute("target", "_self")
        }
        else if(currentLink.includes(`https://${window.location.host}`)){
            console.table("HOST",currentLink)
            tag[i].setAttribute("target", "_self")
            
        }
        else {
            console.table("Blank",currentLink)
            
            tag[i].setAttribute("target", "_blank")
        }
           
    } */
}

document.addEventListener('lazyloaded', function (e) {
    'use strict';
    var options = {
        disableParallax: /iPad|iPhone|iPod|Android/,
        disableVideo: /iPad|iPhone|iPod|Android/,
        speed: 0.1,
    };

    if ($(e.target).parent('.site-cover').length) {
        $(e.target).parent().jarallax(options).addClass('initialized');
    }
});


function search() {
    'use strict';
    if (
        typeof gh_search_key == 'undefined' ||
        gh_search_key == '' ||
        typeof gh_search_migration == 'undefined'
    )
        return;

    var searchInput = $('#search-field');
    var searchButton = $('.search-button');
    var searchResult = $('#search-result');

    // var url =
    //     siteUrl +
    //     '/ghost/api/v3/content/posts/?key=' +
    //     gh_search_key +
    //     '&limit=all&fields=id,title,excerpt,url,updated_at,tags,visibility&order=updated_at%20desc&formats=plaintext';
    var url = new URL(`${siteUrl}/ghost/api/content/posts`)
    url.searchParams.set('key',gh_search_key)
    url.searchParams.set('limit','all')
    url.searchParams.set('fields',`id,title,excerpt,url`)
    url.searchParams.set('formats','plaintext')

    var indexDump = JSON.parse(localStorage.getItem('ease_search_index'));
    var index;
    var current;
    var tempResults;
    
    elasticlunr.clearStopWords();

    // localStorage.removeItem('ease_search_index');
    // localStorage.removeItem('ease_search_last');
    function update(data) {
        data.posts.forEach(function (post) {
            index.addDoc(post);
        });

        // localStorage.setItem('ease_search_index', JSON.stringify(index));
        // localStorage.setItem('ease_search_last', data.posts[0].updated_at);
    }

    if (
        !indexDump ||
        gh_search_migration != localStorage.getItem('ease_search_migration')
    ) {
        // $.get(url, function (data) {
        //     if (data.posts.length > 0) {
        //         index = elasticlunr(function () {
        //             this.addField('title');
        //             this.addField('plaintext');
        //             this.setRef('id');
        //         });
        //         console.log("SEARCH DATA", data)
        //         update(data);

        //         localStorage.setItem(
        //             'ease_search_migration',
        //             gh_search_migration
        //         );
        //     }
        // });

        let getPosts = fetch(url,{
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Accept-Version': 'v5.0'
            },
        })
        .then(response => response.json())
        .then(response=> {
            index = elasticlunr(function () {
                this.addField('title');
                this.addField('plaintext');
                this.setRef('id');
            });
            update(response)
        })
        .catch(error=>{
        })
    } else {
        index = elasticlunr.Index.load(indexDump);

        $.get(
            url +
            "&filter=updated_at:>'" +
            localStorage
                .getItem('ease_search_last')
                .replace(/\..*/, '')
                .replace(/T/, ' ') +
            "'",
            function (data) {
                if (data.posts.length > 0) {
                    update(data);
                }
            }
        );
    }


    searchInput.on('keyup', function (e) {
        if (e.key === 'Enter' && e.target.value !== '') {
            let result = index.search(e.target.value, { expand: true });
            let pageOutput = ''
            e.preventDefault();

            result.forEach(function (post,index) {
                
              pageOutput += `
              <div class="bg-white md:px-4 md:py-3 lg:flex lg:flex-col lg:col-span-2 mb-10">
                  <a href="${post.doc.url}" class="">  
                      <h1 class="text-d5 hover:text-blue-700 underline">${post.doc.title}</h1>
                      <small class="pb-0 text-[10px] leading-none md:text-xs mb-2 md:mb-1 text-gray-400">${post.doc.url}</small>
                  </a>
                  <p class="text-sm text-gray-500">${post.doc.excerpt}</p>
              </div>
              `
            });
            localStorage.setItem('searchTerm',e.target.value)
            localStorage.setItem(
              'searchPageContent',
              pageOutput);
            window.location.href = siteUrl + "/search-results";

        } else {
            let result = index.search(e.target.value, { expand: true });
            var output = '';
            let pageOutput = ''
            current = Object.assign(result);
            result.forEach(function (post,index) {
                if(index  < 10) {
                    output += `
                    <div class="border-t border-black/[.1] pt-2 pb-3 px-2 space-y-1 mt-5">
                        <div class="lg:flex lg:justify-between px-2">
                        <div class="text-d5 lg:text-d4 p-2 text-dark-200">
                            <a href="${post.doc.url}" >
                                ${post.doc.title}
                            </a>
                        </div>
                        </div>
                    </div>
                    `
                }
            });

            result.forEach(function (post,index) {
                
                pageOutput += `
                <div class="bg-white md:px-4 md:py-3 lg:flex lg:flex-col lg:col-span-2 mb-10">
                    <a href="${post.doc.url}" class="">  
                        <h1 class="text-d5 hover:text-blue-700 underline">${post.doc.title}</h1>
                        <small class="pb-0 text-[10px] leading-none md:text-xs mb-2 md:mb-1 text-gray-400">${post.doc.url}</small>
                    </a>
                    <p class="text-sm text-gray-500">${post.doc.excerpt}</p>
                </div>
                `
            });

            output += `
            <div class="border-t border-black/[.1] pt-2 pb-3 px-2 space-y-1 mt-5">
                <div class="lg:flex lg:justify-between px-2">
                <div class="text-d5 lg:text-d4 p-2 text-dark-200 text-center">
                    <a href="/search-results/" >
                        See all result(s)
                    </a>
                </div>
                </div>
            </div>
            `

            localStorage.setItem('searchTerm',e.target.value)
            localStorage.setItem(
                'searchPageContent',
                pageOutput);

            searchResult.html(output);
        }

    });

    $('.search-form').on('submit', function (e) {
        e.preventDefault();
    });

    searchButton.on('click', function () {
        var outputPage = '';
        current.forEach(function (post) {
            outputPage +=
                '<div class="col-md-6 search-container mb-3" style="padding: 20px;">' +
                '<article class="u-hover-item">' +
                '<a class="post-link u-permalink" href="' + post.doc.url + '">' +
                '<div class="post-wrapper mt-2">' +
                '<a class="post-title-link" href="' + post.doc.url + '">' +
                '<b>' + post.doc.title + '</b>' +
                '</a>' +
                '<div class="post-excerpt">' +
                post.doc.excerpt +
                '</div>' +
                '</div>' +
                '</a>' +
                '</article>' +
                '</div>';
        });

        localStorage.setItem(
            'searchPageContent',
            current);

        window.location.href = siteUrl + "/search-results";
    });

    $(document).keyup(function (e) {
        if (e.keyCode === 27) {
            searchInput.val('').focus().keyup();
        }
    });
}

function featured() {
    'use strict';
    $('.featured-posts').owlCarousel({
        dots: false,
        margin: 30,
        nav: true,
        navText: [
            '<i class="icon icon-chevron-left"></i>',
            '<i class="icon icon-chevron-right"></i>',
        ],
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
            992: {
                items: 4,
            },
        },
    });
}

function video() {
    'use strict';
    $('.post-content').fitVids();
}

function gallery() {
    'use strict';
    var images = document.querySelectorAll('.kg-gallery-image img');

    images.forEach(function (image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
    });
}

function table() {
    'use strict';
    if (body.hasClass('post-template') || body.hasClass('page-template')) {
        var tables = $('.post-content').find('.table');
        tables.each(function (_, table) {
            var labels = [];

            $(table)
                .find('thead th')
                .each(function (_, label) {
                    labels.push($(label).text());
                });

            $(table)
                .find('tr')
                .each(function (_, row) {
                    $(row)
                        .find('td')
                        .each(function (index, column) {
                            $(column).attr('data-label', labels[index]);
                        });
                });
        });
    }
}

function mobileMenu() {
    'use strict';
    $('.burger').on('click', function () {
        $('body').toggleClass('menu-opened');
    });
}

